import {
  Get, Delete, Post, Put,
} from '../requestBuilder/buildFetchRequest';
import PagedResponse from '../PagedResponse';
import Timecard from './TimeCard';
import TimecardQueryOptions from './TimecardQueryOptions';
import AddTimeCardByHours from './AddTimeCardByHours';
import AddTimeCardByTime from './AddTimeCardByTime';
import UpdateTimeCardByHours from './UpdateTimeCardByHours';
import UpdateTimeCardByHoursBatch from './UpdateTimeCardByHoursBatch';
import UpdateTimeCardByTime from './UpdateTimeCardByTime';
import { QueryParameters, buildQueryParams } from '../QueryParameters';
import TimeCardMigrationStatus from './TimeCardMigrationStatus';

export const getTimecards = (query: QueryParameters<Timecard, TimecardQueryOptions>): Promise<PagedResponse<Timecard>> => (
  Get('/api/timecards')
    .AddQueryParams(buildQueryParams(query))
    .Execute()
);

export const getMyTimecards = (query: QueryParameters<Timecard, Omit<TimecardQueryOptions, 'employeeId'>>): Promise<PagedResponse<Timecard>> => (
  Get('/api/my/timecards')
    .AddQueryParams(buildQueryParams(query))
    .Execute()
);

export const getTimecard = (id: number): Promise<Timecard> => (
  Get(`/api/timecards/${id}`)
    .Execute()
);

export const addTimeCardByHours = (request: AddTimeCardByHours): Promise<void> => (
  Post('/api/timecards/hoursBased')
    .AddBody(request)
    .Execute()
);

export const addTimeCardByTime = (request: AddTimeCardByTime): Promise<void> => (
  Post('/api/timecards/timeBased')
    .AddBody(request)
    .Execute()
);

export const deleteTimeCard = (id: number): Promise<void> => (
  Delete(`/api/timecards/${id}`)
    .Execute()
);

export const deleteTimeCardBatch = (batchId: string): Promise<void> => (
  Delete(`/api/timecards/hoursBased/${batchId}`)
    .Execute()
);

export const updateTimeCardByHours = (id: number, request: UpdateTimeCardByHours): Promise<void> => (
  Put(`/api/timecards/hoursBased/${id}`)
    .AddBody(request)
    .Execute()
);

export const updateTimeCardByHoursBatch = (batchId: string, request: UpdateTimeCardByHoursBatch): Promise<void> => (
  Put(`/api/timecards/hoursBased/${batchId}/batch`)
    .AddBody(request)
    .Execute()
);

export const updateTimeCardByTime = (id: number, request: UpdateTimeCardByTime): Promise<void> => (
  Put(`/api/timecards/timeBased/${id}`)
    .AddBody(request)
    .Execute()
);

export const getTimeCardMigrationStatus = (): Promise<TimeCardMigrationStatus> => (
  Get('/api/timecards/migration')
    .Execute()
);

export const performTimecardMigration = (): Promise<void> => (
  Post('/api/timecards/migration')
    .AddBody({})
    .Execute()
);

export const timecardGroupableColumns: (keyof Timecard)[] = [
  'actualHours',
  'ardocDetailId',
  'batchId',
  'batched',
  'billable',
  'comments',
  'custom1',
  'custom2',
  'custom3',
  'custom4',
  'custom5',
  'custom6',
  'custom7',
  'custom8',
  'date',
  'empNumber',
  'employeeFullName',
  'employeeFirstName',
  'employeeId',
  'employeeLastName',
  'endTime',
  'hourClass',
  'hourDrawing',
  'hourFactor',
  'hourRate',
  'hourTime',
  'hourTypeId',
  'hourTypeName',
  'nonConformanceId',
  'nonConformanceName',
  'processScheduleDetailId',
  'processScheduleDetailName',
  'projectId',
  'projectName',
  'quantity',
  'specId',
  'specName',
  'startTime',
  'timePeriodId',
  'timeSheetId',
  'timecardPunchInID',
  'validated',
];

export const timecardFilterableColumns: (keyof TimecardQueryOptions)[] = [
  'employeeId',
  'actualHours',
  'batchId',
  'comments',
  'custom1',
  'custom2',
  'custom3',
  'custom4',
  'custom5',
  'custom6',
  'custom7',
  'custom8',
  'date',
  'editable',
  'employeeFirstName',
  'employeeId',
  'employeeLastName',
  'endTime',
  'hourTypeId',
  'hourTypeName',
  'nonConformanceId',
  'nonConformanceName',
  'processScheduleDetailId',
  'processScheduleDetailName',
  'projectId',
  'projectName',
  'quantity',
  'roundedHours',
  'specId',
  'specName',
  'startTime',
  'timeSheetId',
  'locked',
];

export const timecardSortableColumns: (keyof Timecard)[] = [
  ...timecardGroupableColumns,
  'id',
];
